import PropTypes from 'prop-types';
import { withLogin } from 'Components/hocs';
import { logException, ROUTES } from 'Utils';
const REDIRECT_URL_TIMEOUT = 3000;

const WelcomeBack = ({ applicationConfig, strings, transitionTo, uim }) => {
  const logout = async () => {
    try {
      await uim.logout();
      setTimeout(() => {
        transitionTo(ROUTES.PAGE_VALIDATE.url);
      }, REDIRECT_URL_TIMEOUT);
    } catch (err) {
      logException(e);
    }
  };

  logout();

  return (
    <>
      <div className="icon--success" />
      <h1 className="page-heading">{applicationConfig.cta1 || strings.cta1}</h1>
    </>
  );
};

WelcomeBack.propTypes = {
  applicationConfig: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

export default withLogin(WelcomeBack);
